module.exports = __webpack_public_path__ + "img/ba.0dd4db87.svg";